import {Table, Text} from "@mantine/core";
import {IShipment} from "../../../api/Shipment/Shipment.types";

interface Props {
    shipments:IShipment[],
    onReferenceNumberClick:(referenceNumber:string)=>void,
}

function ShipmentTable(props:Props){
    const { shipments, onReferenceNumberClick } = props;

    const rows = shipments.map((shipment) => {
        const { referenceNumber, csr, status, salesOrder, po } = shipment;

        return (
            <tr key={shipment.referenceNumber}>
                <td><Text variant="link" size="sm" color="blue" sx={()=>({"&:hover":{ cursor:"pointer" }})} onClick={()=>onReferenceNumberClick(referenceNumber)}>{referenceNumber}</Text></td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{csr}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{status}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{salesOrder}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{po}</td>
            </tr>
        )
    });

    return (
        <Table striped>
            <thead>
            <tr>
                <th>Ref #</th>
                <th>CSR</th>
                <th>Status</th>
                <th>Sales Order</th>
                <th>PO</th>
            </tr>
            </thead>
            <tbody>{rows}</tbody>
        </Table>
    )
}

export default ShipmentTable;